// componente che contiene i metodi di gestione dell'utente corrente (get, set e remove) sullo storage locale;
// questi metodi permettono di verificare se e quale utente è loggato nell'applicativo

import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
    username: string;
    telephone: string;
    email: string;
    firstname: string;
    bodyid: string;
    lastname: string;
    profile: string;
    token: string;
}
@Injectable({
    providedIn: 'root'
})
export class CurrentUserService {
    private _currentUserSubject: BehaviorSubject<User>;

    constructor(
    ) {
        this._currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    }

    public get currentUser(): User {
        return this._currentUserSubject.value;
    }

    public set currentUser(user: User) {
        if (!this.currentUser || user && user.username === this.currentUser.username) {
            localStorage.setItem('currentUser', JSON.stringify(user));
            this._currentUserSubject.next(user);
        }
    }

    public removeCurrentUser() {
        this._currentUserSubject.next(null);
        localStorage.removeItem('currentUser');
    }
}
